import type { LegalDocument, LegalLocale } from './types'
import { personalDataConsent, privacyPolicy, termsOfService } from './shortDocuments'
import { userAgreement } from './userAgreement'

const documents = {
  privacy: privacyPolicy,
  terms: termsOfService,
  consent: personalDataConsent,
  offer: userAgreement,
} as const

export type LegalDocumentId = keyof typeof documents

export function legalDocument(id: LegalDocumentId, locale: string): LegalDocument {
  const pack = documents[id]
  if (locale === 'en' || locale === 'ky') return pack[locale]
  return pack.ru
}

export type { LegalLocale }
